<template>
	<!-- 지점 상세 정보 표 (웹 지점찾기 상세와 같은 순서·모양) -->
	<dl class="shop-detail-table">
		<div v-for="row in rows" :key="row.label" class="shop-detail-table__row">
			<dt class="shop-detail-table__label">{{ row.label }}</dt>
			<dd class="shop-detail-table__value">
				<a v-if="row.href" :href="row.href" class="shop-detail-table__link">{{ row.value }}</a>
				<template v-else>{{ row.value }}</template>
			</dd>
		</div>
	</dl>
</template>

<script>
import { convertHtmlToText } from '@/utils/util';

// '(요일)' 이나 '※' 앞에서 줄을 나눠, 요일 묶음이 중간에 끊기지 않게 한다.
function splitHours(text) {
	return (text || '').trim().replace(/\s+(?=[(※])/g, '\n');
}

// 전화 걸기 링크 (tel:) - 숫자와 '+' 만 남긴다. 예) '02-482-1131' → 'tel:024821131'
function telHref(tel) {
	const digits = (tel || '').replace(/[^0-9+]/g, '');
	return digits ? `tel:${digits}` : '';
}

export default {
	props: {
		// 지점 정보 (shop_article_shop 컬럼: ar_addr1, ar_content, ar_parking ...)
		item: {
			type: Object,
			required: true,
		},
	},
	computed: {
		rows() {
			const item = this.item;
			const directions = convertHtmlToText(item.ar_content || '').trim();
			const hours = [splitHours(item.ar_time1), splitHours(item.ar_time2)]
				.filter(Boolean)
				.join('\n');

			return [
				{ label: '주소', value: `${item.ar_addr1 || ''} ${item.ar_addr2 || ''}`.trim() },
				{ label: '상세안내', value: directions },
				{ label: '주차여부', value: item.ar_parking },
				{ label: '주차상세', value: convertHtmlToText(item.ar_parking_detail || '').trim() },
				{ label: '지점 연락처', value: item.shop_tel, href: telHref(item.shop_tel) },
				{ label: '영업시간', value: hours },
			].filter((row) => row.value);
		},
	},
};
</script>

<style scoped>
/* 다이얼로그 본문의 white-space: pre-line 을 끊어, 태그 사이 공백이 빈 줄로 보이지 않게 한다 */
.shop-detail-table {
	margin: 0;
	text-align: left;
	white-space: normal;
}

/* 표 형식: 왼쪽 라벨(고정 폭) + 오른쪽 내용, 줄 사이 얇은 구분선 */
.shop-detail-table__row {
	display: grid;
	grid-template-columns: 5.5em 1fr;
	column-gap: 0.75rem;
	padding: 0.625rem 0;
	border-top: 1px solid #e5e5e5;
}

.shop-detail-table__row:first-child {
	padding-top: 0;
	border-top: none;
}

.shop-detail-table__label {
	color: #888;
	font-weight: 500;
}

.shop-detail-table__value {
	margin: 0;
	color: #222;
	word-break: keep-all;
	white-space: pre-line;
}

/* 누르면 전화 연결되는 번호: 밑줄로 누를 수 있음을 표시 */
.shop-detail-table__link {
	color: inherit;
	text-decoration: underline;
	text-underline-offset: 3px;
}
</style>
